 <!-- Chat Modal -->
  <div class="chat-modal" *ngIf="isOpen && showChatHistoryButton">
    <div class="chat-content">
      <div class="chat-header">
        <h3 style="font-weight: 700; color: #000; margin-right: 3px">
          Comment History
        </h3>
        <button class="chat-modal-close-btn" (click)="closeChat()">
          Close
        </button>
      </div>

      <div class="chat-body">
        <p>
          <strong>RFQ - Buyer Comments</strong> sent an RFQ on
          {{ formatDateToDDMMYYYY(headerData.rfqDate) }}
        </p>
        <p>
          RFQ Ref Number: <strong>{{ headerData.rfqRefNumber }}</strong>
        </p>

        <!-- Vessel Info on Right -->
        <div class="vessel-info">
          <p>
            Vessel Name: <strong>{{ headerData.vesselName }}</strong>
          </p>
          <p>
            Vessel IMO Number: <strong>{{ headerData.vesselImoNumber }}</strong>
          </p>
          <p>
            Port Name: <strong>{{ headerData.portName }}</strong>
          </p>
          <p>
            Vessel ETA:
            <strong>{{ formatDateToDDMMYYYY(headerData.vesselEta) }}</strong>
          </p>
          <p>
            Vessel ETD:
            <strong>{{ formatDateToDDMMYYYY(headerData.vesselEtd) }}</strong>
          </p>
        </div>

        <!-- Chat Messages -->
        <!-- <div class="chat-messages">
          <div class="msg incoming">
            <span class="text">
              Could you clarify the lead time for the delivery of the equipment
              listed under Item Q017? Additionally, are there any options for
              expedited shipping if required?
            </span>
            <span class="time">08:10 PM</span>
          </div>

          <div class="msg outgoing">
            <span class="text">
              Thank you for your inquiry. The lead time for Item Q017 is
              approximately 7–8 business days. We also offer expedited shipping,
              which would reduce the delivery time to 2–3 days. Please let us
              know if this is required for your order.
            </span>
            <span class="time">08:10 PM</span>
          </div>
        </div> -->

        <div class="chat-messages">
          <div
            *ngFor="let msg of messages"
            class="msg"
            [ngClass]="{
              incoming: msg.sender !== 'You',
              outgoing: msg.sender === 'You'
            }"
          >
            <span class="text" [innerHTML]="msg.message"></span>
            <span class="time">{{ msg.time }}</span>
            <!-- Optional timestamp -->
          </div>
        </div>
      </div>

      <!-- Footer with File Upload Icon -->
      <div class="chat-footer">
        <label class="file-upload">
          📎
          <input type="file" hidden (change)="onFileSelected($event)" />
        </label>
        <input
          type="text"
          placeholder="Type a message"
          [(ngModel)]="newMessage"
        />
        <button (click)="sendMessage()">Send</button>
      </div>
    </div>
  </div>
